import { connect } from 'react-redux';
import actions from '../../store/actions';
import Auth from './auth';

export default connect(({ auth }) => ({ ...auth }), actions.auth)(Auth);
